// extracted by mini-css-extract-plugin
module.exports = {"root":"UploadUserAvatar_root__3N164","uploadingImageOverlay":"UploadUserAvatar_uploadingImageOverlay__2secI","actionButton":"UploadUserAvatar_actionButton__3tU60"};